export function normalizeSnakeCase(val: string): string {
  return val
    .split('_')
    .map((s: string) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ')
}

interface InvoiceItem {
  description?: string | null
  amount?: number | string
}

/**
 * Whether an invoice's line items are worth showing as a breakdown.
 *
 * Most invoices carry one description-less lump-sum item equal to the total (amount-only sources:
 * partner API, CSV, consumer, paybytxt), which just repeats the total shown beneath it. Only a
 * genuinely categorized invoice — more than one item, at least one real description — earns it.
 */
export function hasInvoiceBreakdown(items?: InvoiceItem[] | null): boolean {
  if (!Array.isArray(items) || items.length < 2) {
    return false
  }

  return items.some(
    item => typeof item?.description === 'string' && !!item.description.trim()
  )
}

export function roundMoney(num: number, decimalPlaces = 2) {
  const multiplier = Math.pow(10, decimalPlaces)
  const scaled = +(decimalPlaces ? num * multiplier : num).toFixed(8)
  const integerPart = Math.floor(scaled)
  const fractionalPart = scaled - integerPart
  const epsilon = 1e-8

  const isHalf =
    fractionalPart > 0.5 - epsilon && fractionalPart < 0.5 + epsilon
  const rounded = isHalf
    ? integerPart % 2 === 0
      ? integerPart
      : integerPart + 1
    : Math.round(scaled)

  return decimalPlaces ? rounded / multiplier : rounded
}
